import React, { useState, useEffect } from "react";
import API from "../../helper/AxiosInterceptor";
import { toast } from "react-toastify";
import { Loader } from "../Loader";

const WalletWhitelistTab = ({ appId }) => {
    const [wallets, setWallets] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);
    const [showOtpModal, setShowOtpModal] = useState(false);

    const [newWallet, setNewWallet] = useState({ address: '', label: '', network: '' });
    const [otp, setOtp] = useState("");
    const [pendingAction, setPendingAction] = useState(null); // 'add' or { type: 'remove', address: '...' }

    const fetchWallets = async () => {
        setLoading(true);
        try {
            const response = await API.get(`${process.env.REACT_APP_API_URL}/apps/whitelist?appId=${appId}`, {
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
            });
            if (response?.data?.success) {
                setWallets(response.data.data);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (appId) fetchWallets();
    }, [appId]);

    // Request OTP functions
    const handleRequestOtpAdd = async (e) => {
        e.preventDefault();
        if (!newWallet.address || !newWallet.network || !newWallet.label) {
            toast.error("Please fill all fields!");
            return;
        }
        await requestOtp();
        setPendingAction('add');
        setShowAddModal(false);
        setShowOtpModal(true);
    };

    const handleRequestOtpRemove = async (address) => {
        await requestOtp();
        setPendingAction({ type: 'remove', address });
        setShowOtpModal(true);
    };

    const requestOtp = async () => {
        setLoading(true);
        try {
            const resp = await API.post(
                `${process.env.REACT_APP_API_URL}/apps/whitelist/request-otp`,
                { appId },
                { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
            );
            if (resp?.data?.success) {
                toast.success(resp.data.message || "OTP Sent!");
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Failed to send OTP");
        } finally {
            setLoading(false);
        }
    };

    const handleSubmitOtp = async (e) => {
        e.preventDefault();
        if (!otp) {
            toast.error("Please enter the OTP");
            return;
        }
        setLoading(true);
        try {
            if (pendingAction === 'add') {
                const resp = await API.post(
                    `${process.env.REACT_APP_API_URL}/apps/whitelist/add`,
                    { appId, address: newWallet.address, label: newWallet.label, network: newWallet.network, otp },
                    { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
                );
                if (resp?.data?.success) {
                    toast.success("Wallet Added Successfully");
                    setShowOtpModal(false);
                    setNewWallet({ address: '', label: '', network: '' });
                    fetchWallets();
                }
            } else if (pendingAction?.type === 'remove') {
                const resp = await API.delete(
                    `${process.env.REACT_APP_API_URL}/apps/whitelist/remove`,
                    {
                        data: { appId, address: pendingAction.address, otp },
                        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
                    }
                );
                if (resp?.data?.success) {
                    toast.success("Wallet Removed Successfully");
                    setShowOtpModal(false);
                    fetchWallets();
                }
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Invalid OTP or Action Failed");
        } finally {
            setLoading(false);
            setOtp("");
        }
    };

    return (
        <div className="white-bg my-apps-content padd20 mt-4">
            {loading && <Loader inline={true} />}
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h4>Whitelisted Wallets</h4>
                <button className="btn" onClick={() => setShowAddModal(true)}>Add New +</button>
            </div>
            <div className="table-box">
                <table className="table">
                    <thead>
                        <tr>
                            <th>Wallet Address</th>
                            <th>Label</th>
                            <th>Network</th>
                            <th style={{ textAlign: "right" }}>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {wallets && wallets.length > 0 ? (
                            wallets.map((w, index) => (
                                <tr key={index}>
                                    <td>{w.address}</td>
                                    <td>{w.label}</td>
                                    <td>{w.network}</td>
                                    <td style={{ textAlign: "right" }}>
                                        <button className="btn py-1 px-3" style={{ backgroundColor: "rgba(228, 31, 57, 0.25)", color: "#e41f39", minWidth: "auto", border: "none" }} onClick={() => handleRequestOtpRemove(w.address)}>Remove</button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="4" className="text-center">No Whitelisted Wallets Found</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Add Modal */}
            {showAddModal && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title fs-5">Add Whitelisted Wallet</h5>
                                <button type="button" className="btn-close" onClick={() => setShowAddModal(false)}></button>
                            </div>
                            <div className="modal-body api-key-modal">
                                <form onSubmit={handleRequestOtpAdd}>
                                    <div className="form-group app-id-box mb-3">
                                        <label>Wallet Address</label>
                                        <div className="form-group-inner">
                                            <input type="text" className="form-control" value={newWallet.address} onChange={(e) => setNewWallet({ ...newWallet, address: e.target.value })} required />
                                        </div>
                                    </div>
                                    <div className="form-group app-id-box mb-3">
                                        <label>Label</label>
                                        <div className="form-group-inner">
                                            <input type="text" className="form-control" placeholder="e.g. Binance Deposit" value={newWallet.label} onChange={(e) => setNewWallet({ ...newWallet, label: e.target.value })} required />
                                        </div>
                                    </div>
                                    <div className="form-group app-id-box mb-3">
                                        <label>Network</label>
                                        <div className="form-group-inner">
                                            <input type="text" className="form-control" placeholder="e.g. TRX, BSC, BTC" value={newWallet.network} onChange={(e) => setNewWallet({ ...newWallet, network: e.target.value })} required />
                                        </div>
                                    </div>
                                    <button type="submit" className="btn w-100">Request OTP To Add</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* OTP Modal */}
            {showOtpModal && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title fs-5">Enter OTP to Confirm</h5>
                                <button type="button" className="btn-close" onClick={() => setShowOtpModal(false)}></button>
                            </div>
                            <div className="modal-body api-key-modal">
                                <p>An OTP has been sent to your registered email address.</p>
                                <form onSubmit={handleSubmitOtp}>
                                    <div className="form-group app-id-box mb-3">
                                        <label>Enter 6-digit OTP</label>
                                        <div className="form-group-inner">
                                            <input type="text" className="form-control" value={otp} onChange={(e) => setOtp(e.target.value)} required maxLength={6} />
                                        </div>
                                    </div>
                                    <button type="submit" className="btn w-100">Confirm</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
};

export default WalletWhitelistTab;
